import { bsc, bscGreenfield, bscTestnet, opBNB, opBNBTestnet } from '@reown/appkit/networks'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { cookieStorage, createStorage } from 'wagmi'

export const projectId = import.meta.env.VITE_PUBLIC_PROJECT_ID as string

if (!projectId) {
  throw new Error('Project ID is not defined')
}

export const networks = [bsc, bscTestnet, bscGreenfield, opBNB, opBNBTestnet]

export const wagmiAdapter = new WagmiAdapter({
  storage: createStorage({
    storage: cookieStorage,
  }),
  ssr: true,
  projectId,
  networks,
})

export const config = wagmiAdapter.wagmiConfig
